import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { EmployeeRequestService } from '../../services/employee-request.service'
import {
  createEmployeeRequest,
  createEmployeeRequestFailure,
  createEmployeeRequestsSuccess,
  loadEmployeeRequests,
  loadEmployeeRequestsFailure,
  loadEmployeeRequestsSuccess,
  updateEmployeeRequest,
  updateEmployeeRequestFailure,
  updateEmployeeRequestsSuccess
} from './employee-request.actions'

export const loadEmployeeRequests$ = createEffect(
  (actions$ = inject(Actions), employeeRequestService = inject(EmployeeRequestService)) =>
    actions$.pipe(
      ofType(loadEmployeeRequests),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          employeeRequestService.getEmployeeRequests(action.params, action.page, action.limit).pipe(
            map(res =>
              loadEmployeeRequestsSuccess({
                totalCount: res.totalCount,
                empRequests: res.empRequests
              })
            ),
            catchError(error => of(loadEmployeeRequestsFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createEmployeeRequest$ = createEffect(
  (
    actions$ = inject(Actions),
    employeeRequestService = inject(EmployeeRequestService),
    toastr = inject(ToastrService), // Inject the ToastrService
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createEmployeeRequest),
      exhaustMap(({ userId, requestBy, requestType, request, status }) =>
        employeeRequestService
          .createEmployeeRequest({ userId, requestBy, requestType, request, status })
          .pipe(
            map(created => {
              // Dispatch the success action
              const successAction = createEmployeeRequestsSuccess({ empRequest: created })

              // Show a success message using Toastr
              toastr.success('Request created successfully!', 'Success')
              // store.dispatch(loadEmployeeRequests({ params: null, page: 1, limit: 10 }))
              modalService.dismissAll()
              return successAction
            }),
            catchError(error => {
              // Optionally, show an error message
              toastr.error(error.error.message, 'Error')
              return of(createEmployeeRequestFailure({ error }))
            })
          )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateEmployeeRequest$ = createEffect(
  (
    actions$ = inject(Actions),
    employeeRequestService = inject(EmployeeRequestService),
    toastr = inject(ToastrService),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateEmployeeRequest),
      exhaustMap(({ id, payload }) =>
        employeeRequestService.updateEmployeeRequest(id, payload).pipe(
          map(updatedRequest => {
            toastr.success(`Request ${payload.status} successfully!`, 'Success')

            // Dispatch loadBusinessById after the update is successful
            // store.dispatch(loadEmployeeRequests({ params: null }))
            modalService.dismissAll()
            // Dispatch success action to update the store
            return updateEmployeeRequestsSuccess({ empRequest: updatedRequest })
          }),
          catchError(error => {
            // toastr.error('Failed to update request', 'Error') // Show error message
            toastr.error(error.error.message, 'Error')

            return of(updateEmployeeRequestFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const employeeRequestEffects = {
  loadEmployeeRequests$,
  createEmployeeRequest$,
  updateEmployeeRequest$
}
